import React from "react";
import { formatVolume } from "utils";
import "./cashin-limit-modal.scss";

const CashInLimitModal = ({
  isOpen,
  title = "Cash In Limit",
  limits = [],
  currencySymbol = "₱",
  valueFormat = "currency",
}) => {
  if (!isOpen) return null;

  /**
   * Props:
   * @param {boolean} isOpen - Whether tooltip is visible
   * @param {string} title - Custom title (defaults to "Cash In Limit")
   * @param {Array} limits - Array of limit objects with { period, resetInfo, current, limit }
   * @param {string} currencySymbol - Currency symbol (defaults to "₱")
  * @param {"currency"|"volume"} valueFormat - Value formatting mode (defaults to "currency")
   */

  const defaultLimits = [
    {
      period: "Daily",
      resetInfo: "Resets daily at 12 midnight",
      current: 0,
      limit: 0,
    },
    {
      period: "Weekly",
      resetInfo: "Resets every Tuesday at 7am",
      current: 0,
      limit: 0,
    },
    {
      period: "Monthly",
      resetInfo: "Resets every first day of the month at 12 midnight",
      current: 0,
      limit: 0,
    },
  ];

  const resolvedLimits = limits.length > 0 ? limits : defaultLimits;

  const formatCurrency = (amount, symbol = currencySymbol) => {
    return `${symbol}${Number(amount || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const formatValue = (amount) => {
    if (valueFormat === "volume") {
      return formatVolume(Number(amount || 0));
    }

    return formatCurrency(amount, currencySymbol);
  };

  const isUnlimited = (limit) => {
    return limit == null;
  };

  const calculatePercentage = (current, limit) => {
    if (!limit || limit <= 0) return 0;
    return Math.min((current / limit) * 100, 100);
  };

  return (
    <div className="cashin-limit-tooltip" role="tooltip">
      <div className="cashin-limit-tooltip-header">{title}</div>

      <div className="limits-container">
        {resolvedLimits.map((item, index) => (
          <div key={index} className="limit-item">
            <div className="limit-header">
              <h3>{item.period}</h3>
              <span className="limit-amount">
                {isUnlimited(item.limit)
                  ? "Unlimited"
                  : `${formatValue(item.current)} / ${formatValue(item.limit)}`}
              </span>
            </div>
            <p className="reset-info">{item.resetInfo}</p>
            <div className="progress-bar">
              {!isUnlimited(item.limit) && (
                <div
                  className="progress-fill"
                  style={{ width: `${calculatePercentage(item.current, item.limit)}%` }}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CashInLimitModal;